// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bM0PzRipp3Mz6DEoYcCO{justify-content:space-between;width:100%;font-size:13px;line-height:16px;display:flex}.FPvqPkmup34UKT1jtqsw{margin-right:8px}.bwA6fhoUvegpJIBURBqK{color:var(--gray-100);text-underline-offset:2px;margin-left:4px;text-decoration:underline}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `bM0PzRipp3Mz6DEoYcCO`,
	"backButton": `FPvqPkmup34UKT1jtqsw`,
	"agreedLink": `bwA6fhoUvegpJIBURBqK`
};
export default ___CSS_LOADER_EXPORT___;
